import { tokens } from "../../context/weet-tokens.js";
const inputNumberThemeConfig = {
    tokens: {
        activeBorderColor: tokens.weetColorBorderSelect,
        activeShadow: 'none',
        addonBg: '#ffffff',
        controlWidth: 240,
        errorActiveShadow: 'none',
        filledHandleBg: tokens.weetColorBackgroundNeutralWhite,
        handleActiveBg: tokens.weetColorBorderNeutralSubtler,
        handleBg: tokens.weetColorBackgroundNeutralWhite,
        handleBorderColor: tokens.weetColorBorderNeutralSubtler,
        handleFontSize: 12,
        handleHoverColor: tokens.weetColorIconDefaultNormal,
        handleWidth: 20,
        hoverBorderColor: tokens.weetColorBorderBrandHover,
        inputFontSizeLG: 14,
        warningActiveShadow: 'none'
    }
};
export { inputNumberThemeConfig };
